import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDatepickerInputEvent } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { FormControl } from '@angular/forms';
import { HOURS, MINUTES15 } from '../../common/constants';
import { EXCHANGE_STATUS } from '../holiday-dialog/holiday-dialog.component'

export interface DialogData {
  any
}

/**
 * 振替登録のキー
 */
export const EXCHANGE_KEY = ['7', '9', '10', '11']

@Component({
  selector: 'app-exchange-dialog',
  templateUrl: './exchange-dialog.component.html',
  styleUrls: ['./exchange-dialog.component.less']
})
export class ExchangeDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 画面上半分に表示するデータ
  exchangeDialogData: any;

  // 振替元の日付（休む日）
  day: string = moment(this.data['day']).format('YYYY-MM-DD');

  // 画面表示用日付
  dayForDisp: string = moment(this.data['day']).format('YYYY/MM/DD');

  // 振替先のカレンダー：開いたときに出す月（振替元の日の月）
  originDate: Date = moment(this.data['day']).toDate();

  // 振替先のカレンダー：振替元の日に付けるクラス（紫の輪。今日の丸は styles.less で消している）
  originClass = (d: Date) => moment(d).format('YYYY-MM-DD') == this.day ? 'origin-day' : '';

  // 物件名
  siteName: '';

  // 既存の休みデータ
  holiday = {};

  // 時間ドロップダウン
  hours: number[] = HOURS;

  // 分ドロップダウン
  minutes: string[] = MINUTES15;

  // 休み種別
  statusChoices = [
    {key: '7', value: '休み'},
    {key: '11', value: '欠員'},
    {key: '9', value: '有休'},
    {key: '10', value: '有休（半日）'},
  ];

  // 休み種別
  type = this.statusChoices[0].key;

  // 有休残数
  paidHolidayLeft = 0;

  // 有休時間
  paidHolidayUsageTime = 0;

  // 「変更を保存」ボタン　活性:true、非活性:false
  saveDisabled:boolean = false;

  /** ローディング */
  loadingCompleteData:boolean = false;

  // 振替先データ
  exchange = [{
    id: null,
    sequenceNumber: this.data['sequenceNumber'],
    staffDailyCleaning: this.data['staffDailyCleaning'],
    cdSite: this.data['cdSite'],
    cdContract: this.data['cdContract'],
    day: moment(this.data['day']).format('YYYY-MM-DD'),
    exchangeDay: '',
    hour: '',
    minute: '00',
    nameSite: this.data['nameSite']
  }];

  // 削除した振替元データのID
  deleteData = [];

  // 振替元のメモ
  holidayNote: '';

  // 雇用指示の実働時間
  workingHours = 0;

  // 契約詳細情報の実働時間
  constractHours = 0;

  // 契約の終了日（YYYY-MM-DD。契約詳細情報の一番遅い終了日。終わりが決まっていなければ null）。終了日の翌日以降の振替先は確認してから登録
  contractEndDate: string = null;
  // 契約の開始日（YYYY-MM-DD。契約詳細情報の一番早い開始日）。開始日より前の振替先も確認してから登録（契約の行の間の空きは見ない。ユーザー決定）
  contractStartDate: string = null;

  constructor(private router: Router, private http: HttpClient, @Inject(MAT_DIALOG_DATA) private data: DialogData, private dialogRef: MatDialogRef<ExchangeDialogComponent>,
    private datePipe: DatePipe, private ngZone: NgZone) { }

  ngOnInit() {
    console.log(this.data)
    this.getData();
    this.getContractPeriod();
  }

  /**
   * 契約の期間を取得（契約詳細情報の全部の行をまとめた開始日・終了日）
   * 代勤専門（000000000）は契約が無いので取らない。取れなかったときは止めない（契約の終了日のチェックだけできない）
   * API: contractDetail/period
   */
  getContractPeriod() {
    this.contractEndDate = null;
    this.contractStartDate = null;
    if (!this.data['cdSite'] || this.data['cdSite'] == '000000000') {
      return;
    }
    this.http.get(
      API_BASE_URL + '/api/v1/contractDetail/period?cdSite=' + encodeURIComponent(this.data['cdSite'])
        + '&cdContract=' + encodeURIComponent(this.data['cdContract'] || ''),
      {headers: this.headers}
    ).subscribe(res => {
      this.contractEndDate = (res && res['endDate']) ? String(res['endDate']).substring(0, 10) : null;
      this.contractStartDate = (res && res['startDate']) ? String(res['startDate']).substring(0, 10) : null;
    }, error => {
      if (error && (error.status == 401 || error.status == 403)) {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
      }
    });
  }

  /**
   * 現場に関係する清掃員情報を取得
   */
  getData() {
    this.http.get(API_BASE_URL + '/api/v1/sites/operationDialog?'
      + 'cdSite=' + this.data['cdSite']
      + '&cdContract=' + this.data['cdContract']
      + '&cdStaff=' + this.data['staffDailyCleaning']
      + '&day=' + this.day
      + '&sequenceNumber=' + this.data['sequenceNumber']
      + '&spot=' + false,
      {headers: this.headers})
      .subscribe((res) => {
        this.siteName = this.data['nameSite'];
        if (res == null || (res as []).length == 0) {
          this.exchangeDialogData = null
        } else {
          this.exchangeDialogData = res;
        }

        // 既存の振替データ取得
        this.http.get(API_BASE_URL + '/api/v1/exchange?sequenceNumber=' + this.data['sequenceNumber']
        + '&staffDailyCleaning=' + this.data['staffDailyCleaning']
        + '&cdSite=' + this.data['cdSite']
        + '&day=' + this.day,
        {headers: this.headers})
        .subscribe((res) => {
          if (res) {
            // 有休残数（対象日以外の有休残数）
            if (res['left'] && (res['left'] as []).length) {
              this.paidHolidayLeft = Number(res['left'][0]['intRes2'])
            }
            // 振替データ
            if (res['exchange'] && (res['exchange'] as []).length) {
              this.exchange = res['exchange'] as []
            }
            // 休み登録あり
            if (res['holiday'] && (res['holiday'] as []).length) {
              const holi = res['holiday'][0]
              // ステータス
              const type = holi.status
              // 振替の種別ならOK
              if (EXCHANGE_STATUS.includes(Number(type))) {
                this.type = type

              // 休み登録の種別の場合
              } else {
                switch (type) {
                  // 有休
                  case '1':
                    this.type = '9'
                  // 指定有休
                  case '6':
                    this.type = '9'
                    break;
                  // 半有休
                  case '8':
                    this.type = '10'
                    break;
                  // 欠員
                  case '2':
                    this.type = '11'
                    break;

                  default:
                    this.type = '7'
                    break;
                }
              }

              // 有休の場合
              if (['9', '10'].includes(this.type)) {
                this.paidHolidayUsageTime = Number(holi['paidHolidayUsageTime'])
              }

              // メモ
              this.holidayNote = holi.note
            }
          }
          this.loadingCompleteData = true;
          this.getTime();
        },
        error => {
          alert("認証に失敗しました");
          this.router.navigate(['/']);
          this.loadingCompleteData = true;
        }
      );

      },
      error => {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        this.loadingCompleteData = true;
      }
    );
  }

  /**
   * 振替先の日を選択
   * @param event 選択日
   * @param i インデックス
   */
  changeDate(event: MatDatepickerInputEvent<Date>, i: number) {
    let d = new FormControl(event.value);
    this.exchange[i].exchangeDay = moment(d.value).format('YYYY-MM-DD');
  }

  /**
   * 保存ボタンイベント
   */
  save() {
    if (!this.validate()) {
      return
    }
    this.saveDisabled = true;

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };

    // 有休の場合
    if (['9', '10'].includes(this.type)) {
      if (!this.paidHolidayLeft || (this.type == '9' && this.paidHolidayLeft < 1) || (this.type == '10' && this.paidHolidayLeft < 0.5)) {
        alert('有休残数が足りないため、「休み」で登録してください')
        this.saveDisabled = false;
        return
      }
      if (!this.paidHolidayUsageTime) {
        alert('有休時間を入力してください')
        this.saveDisabled = false;
        return
      }
    } else {
      this.paidHolidayUsageTime = 0;
    }

    // 休みデータを生成
    let holiday = [];
    holiday.push({
      sequenceNumber: this.data['sequenceNumber'],
      cdSite: this.data['cdSite'],
      staffDailyCleaning: this.data['staffDailyCleaning'],
      day: this.day,
      status: this.type,
      note: this.holidayNote,
      paidHolidayUsageTime: this.paidHolidayUsageTime,
      insertedDate: moment().format('YYYY-MM-DD')
    })

    // 振替元の日の勤務の開始・終了（有休テーブルに控える）。days は日付をキーにしたオブジェクトで、時間帯は workingTime にある
    // 作業開始などの日は「13:00 - 16:00\n作業終了」と2行目に印が付くので、1行目だけを使う。「-」「祝日3h出勤」の日は空
    let start = null
    let end = null

    const dayData = this.data['days'] ? this.data['days'][this.day] : null
    if (dayData && dayData.workingTime) {
      const time = String(dayData.workingTime).split('\n')[0].trim()
      if (time.includes(' - ')) {
        const wtArr = time.split(' - ')
        start = wtArr[0].trim()
        end = wtArr[1].trim()
      }
    }

    const saveData = {
      daysSelected: [this.day],
      note: this.holidayNote,
      list: [{
        sequenceNumber: this.data['sequenceNumber'],
        cdSite: this.data['cdSite'],
        cdContract: this.data['cdContract'],
        nameSite: this.data['nameSite'],
        target: [{
          status: String(this.type),
          day: this.day,
          workingHours: String(this.workingHours),
          start,
          end,
          paidHolidayUsageTime: String(this.paidHolidayUsageTime)
        }]
      }]
    }

    // tbl_operation_note用のデータを生成
    let operationNote = {
      operationNoteId: {
        sequenceNumber: this.data['sequenceNumber'],
        staffDailyCleaning: this.data['staffDailyCleaning'],
        cdSite: this.data['cdSite'],
        day: this.day,
      },
      cdContract: this.data['cdContract'],
      note: this.holidayNote
    }

    this.http.post(
      API_BASE_URL + '/api/v1/status?'
      + 'isRecord=' + false
      + '&isReturnTask=' + false
      + '&staffName=' + this.data['nameStaff']
      + '&staffDailyCleaning=' + this.data['staffDailyCleaning']
      // ユーザーID はメールアドレス（休み登録ダイアログと同じ uid。前は userName を送っていて、ログの登録者が違っていた）
      + '&userId=' + localStorage.getItem("uid")
      + '&deleteData=' + this.deleteData
      + '&isHoliday=' + false,
      { holiday: saveData, exchange: this.exchange },
      httpOptions
    ).subscribe(res => {
      // tbl_operation_noteに保存
      this.http.post(
        API_BASE_URL + '/api/v1/operationNote/save?days=' + [this.day], [operationNote], httpOptions
      ).subscribe(res => {
        this.dialogRef.close(true);
      },error => {
        alert("認証に失敗しました");
        this.dialogRef.close(true);
        return;
      });
    },error => {
      if (error.error.status == 800 && error.error.message != ""){
        alert(error.error.message);
        this.dialogRef.close(true);
      } else if (error.error.status == 801){
        alert(error.error.message);
        this.saveDisabled = false;
      }
      else{
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        this.dialogRef.close();
      }
    });
    // 応答が返るまでボタンは押せないまま（801 で止まったときだけ戻す。二重押しで振替先が2重に入るのを防ぐ）
  }

  /**
   * 閉じるボタンイベント
   */
  close() {
    this.dialogRef.close();
  }

  /**
   * 削除ボタン
   * @param i インデックス
   */
  delete(i) {
    if (this.exchange[i].id) {
      this.deleteData.push(this.exchange[i].id)
    }
    this.exchange.splice(i, 1);
  }

  /**
   * 追加ボタン
   */
  add() {
    let data = {
      id: null,
      sequenceNumber: this.data['sequenceNumber'],
      staffDailyCleaning: this.data['staffDailyCleaning'],
      cdSite: this.data['cdSite'],
      cdContract: this.data['cdContract'],
      day: this.day,
      exchangeDay: '',
      hour: '',
      minute: '00',
      nameSite: this.data['nameSite']
    }
    this.exchange.push(data)
  }


  /**
   * 実働時間取得
   */
  getTime() {
    // 稼働管理の対象日情報
    const dayData = this.data['days'][this.day]

    if (dayData) {
      // 雇用指示の実働時間
      let workingHours = Number.parseFloat(dayData.hours);
      if (!workingHours || isNaN(workingHours) || this.data['sequenceNumber'].includes('-')) {
        workingHours = 0
      }
      this.workingHours = workingHours;

      // 契約詳細情報の実働時間
      let cdHours = Number.parseFloat(dayData.cdHours);
      if (!cdHours || isNaN(cdHours)) {
        cdHours = 0
      }
      this.constractHours = cdHours;
    }
  }

  /**
   * 休み種別変更
   */
  changeType() {
    this.paidHolidayUsageTime = 0;
    if (this.type == '9') {
      this.paidHolidayUsageTime = Number(this.workingHours);
    } else if (this.type == '10') {
      this.paidHolidayUsageTime = Number(this.workingHours) / 2;
    }
  }

  /**
   * バリデート
   * @returns
   */
  validate() {
    let d = [];
    for (let i = 0; i < this.exchange.length; i++) {
      const e = this.exchange[i];
      if (!e.exchangeDay || e.exchangeDay == 'Invalid date' || e.exchangeDay == '') {
        alert((i+1) + '番目の振替先の日付が選択されていません。')
        return false
      }
      if ((e.hour == null || e.hour == '') && e.hour != '0') {
        alert((i+1) + '番目の実働時間が選択されていません。')
        return false
      }
      if (e.minute == null || e.minute == '') {
        alert((i+1) + '番目の実働時間が選択されていません。')
        return false
      }
    }
    // 契約の終了日の翌日以降の振替先があれば確認（契約が終わった物件に時間を回しても誰も清掃しない。止めはしない。ユーザー決定）
    if (this.contractEndDate) {
      const over = this.exchange
        .filter(e => String(e.exchangeDay) > this.contractEndDate)
        .map(e => moment(e.exchangeDay).format('YYYY/MM/DD'))
      if (over.length && !window.confirm('契約詳細情報で契約が終了しています。本当によろしいですか？\r\n\r\n'
        + '契約終了日：' + moment(this.contractEndDate).format('YYYY/MM/DD') + '\r\n'
        + '終了日より後の振替先：' + over.join('、'))) {
        return false
      }
    }
    // 一番早い開始日より前の振替先も同じく確認（契約の行の間の空きは見ない。ユーザー決定）
    if (this.contractStartDate) {
      const before = this.exchange
        .filter(e => String(e.exchangeDay) < this.contractStartDate)
        .map(e => moment(e.exchangeDay).format('YYYY/MM/DD'))
      if (before.length && !window.confirm('契約詳細情報で契約がまだ始まっていません。本当によろしいですか？\r\n\r\n'
        + '契約開始日：' + moment(this.contractStartDate).format('YYYY/MM/DD') + '\r\n'
        + '開始日より前の振替先：' + before.join('、'))) {
        return false
      }
    }
    return true
  }
}
